import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProfileSalaryRequest } from 'src/app/models/profile-salary.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';

@Component({
  selector: 'app-modal-salary-profile',
  templateUrl: './modal-salary-profile.component.html',
  styleUrls: ['./modal-salary-profile.component.scss', '../modal-admin-area/modal-admin-area.component.scss']
})
export class ModalSalaryProfileComponent implements OnInit {
  @Input() isCreating = true;
  @Output() close = new EventEmitter<number>();
  @Input() newSalary: ProfileSalaryRequest = new ProfileSalaryRequest();
  loading = false;
  isRelation = false;

  constructor(
    private toastService: ToastrService,
    private rrhhService: HumanResourcesService
  ) {

  }

  ngOnInit(): void {

  }

  getColumnSpan() {
    let count = 0;
    if (this.newSalary.relationAmount !== null) count++;
    if (this.newSalary.bonusAmount !== null) count++;
    if (this.newSalary.proAmount !== null) count++;
    return count;
  }

  addProfileContract() {
    this.loading = true;
    this.rrhhService.addContractProfile(this.newSalary).subscribe({
      next: (response: ResponseObject) => {
        this.loading = false;
        this.toastService.success("Perfil de contratación creado exitosamente!");
        this.close.emit(response.data.id);
      },
      error: (error: any) => {
        this.loading = false;
        this.toastService.error("Perfil de contratación ya ingresado");
      }
    })
  }

  updateProfileContract() {
    this.loading = true;

    this.rrhhService.updateContractProfile(this.newSalary.id, this.newSalary).subscribe({
      next: (response: ResponseObject) => {
        this.loading = false;
        this.toastService.success("Perfil de contratación actualizado exitosamente!");
        this.close.emit(this.newSalary.id);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  saveProfileContract() {
    if (!this.newSalary) return;

    if (this.isCreating) {
      this.addProfileContract();
    } else {
      this.updateProfileContract();
    }
  }

}
